// Module
var code = "<p>Active permissions define the accounts that have permission to spend funds for this account.</p> <p>They can be used to easily setup a multi-signature scheme, see <a href=\"accounts/permissions\">permissions</a> for more details.</p> ";
// Exports
export default code;